import { render } from "./ClockInsReport.vue?vue&type=template&id=2174e6f1&scoped=true&ts=true"
import script from "./ClockInsReport.vue?vue&type=script&lang=ts"
export * from "./ClockInsReport.vue?vue&type=script&lang=ts"

import "./ClockInsReport.vue?vue&type=style&index=0&id=2174e6f1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2174e6f1"]])

export default __exports__